import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import styles from "./CookiesComp.module.css";

export default function CookiesComp() {
  const [cookies, setCookie] = useCookies(["cookieConsent"]);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    if (!cookies.cookieConsent) setShowBanner(true);
  }, [cookies.cookieConsent]);

  const handleAccept = () => {
    setCookie("cookieConsent", "accepted", {
      path: "/",
      maxAge: 365 * 24 * 60 * 60,
    });
    setShowBanner(false);
  };

  const handleReject = () => {
    setCookie("cookieConsent", "rejected", {
      path: "/",
      maxAge: 365 * 24 * 60 * 60,
    });
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className={styles.cookieBanner}>
      <p>
        We use cookies to improve your experience and analyze website traffic.
        By clicking “Accept”, you consent to our use of cookies.
      </p>
      <div className={styles.cookieBannerButtons}>
        <button className={styles.buttonAccept} onClick={handleAccept}>
          Accept
        </button>
        <button className={styles.buttonReject} onClick={handleReject}>
          Reject
        </button>
      </div>
    </div>
  );
}
